/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Stable priority ordering for dedicated Dependency requests.
 */
export enum RoadmapDependencyPriorityBucket {
    P0 = 'p0',
    P1 = 'p1',
    P2 = 'p2',
    P3 = 'p3',
    P4 = 'p4',
    UNKNOWN = 'unknown',
}
